import { Box, Text, Tooltip } from "@mantine/core";
import { SealCheckIcon } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import classes from "./SheetField.module.css";

export interface SheetFieldProps {
  label: string;
  value?: string | null;
  verified?: boolean;
  mono?: boolean;
  /** true бөгөөд `children` (оролт) өгсөн бол текстийн оронд оролт харагдана. */
  isEdit?: boolean;
  children?: ReactNode;
}

// F24: унших горимд текст; хоосон утга «Оруулаагүй» гэж уншигдана.
export function SheetField({ label, value, verified, mono, isEdit, children }: SheetFieldProps) {
  const { t } = useTranslation("profileForm");
  const editing = !!isEdit && !!children;
  const empty = value === undefined || value === null || String(value).trim() === "";

  return (
    <Box className={classes.row} data-edit={editing || undefined}>
      <Text span className={classes.label}>
        {label}
      </Text>
      {editing ? (
        <Box>{children}</Box>
      ) : (
        <Text span className={classes.value} data-empty={empty || undefined} data-mono={(mono && !empty) || undefined}>
          {empty ? t("sheet.empty") : value}
          {!empty && verified && (
            <Tooltip label={t("sheet.verified")} withArrow>
              <Box component="span" className={classes.verified} role="img" aria-label={t("sheet.verified")}>
                <SealCheckIcon size={18} weight="fill" />
              </Box>
            </Tooltip>
          )}
        </Text>
      )}
    </Box>
  );
}
